import React from "react";

/**
 * KeyValue — editorial key/value pair.
 * Mono eyebrow label on top, serif/sans value below.
 */
export function KeyValue({ label, value, valueFont = "sans", className = "", testid }) {
  const valueCls =
    valueFont === "serif"
      ? "font-serif text-lg sm:text-xl leading-[1.25] text-[hsl(var(--foreground))]"
      : "font-body text-sm sm:text-base text-[hsl(var(--foreground))]";
  return (
    <div className={className} data-testid={testid}>
      <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[hsl(var(--foreground-muted))]">
        {label}
      </div>
      <div className={`mt-1.5 ${valueCls}`}>
        {value || <span className="text-[hsl(var(--foreground-muted))]">—</span>}
      </div>
    </div>
  );
}
